export default {
  root: ({ props, parent }) => ({
    class: [
      // Display
      'inline-flex',

      { 'flex-col': props.showButtons && props.buttonLayout === 'vertical' },

      // Shape
      {
        'first:rounded-l-md rounded-none last:rounded-r-md':
          parent.instance.$name === 'InputGroup' && !props.showButtons,
      },
      {
        'border-0 border-y border-l last:border-r border-surface-300':
          parent.instance.$name === 'InputGroup' && !props.showButtons,
      },
      { 'first:ml-0 -ml-px': parent.instance.$name === 'InputGroup' && !props.showButtons },

      //Sizing
      { 'w-16!': props.showButtons && props.buttonLayout === 'vertical' },
    ],
  }),
  input: {
    root: ({ parent, context }) => ({
      class: [
        // Display
        'flex flex-auto',

        // Font
        'font-sans leading-none',

        //Text
        { 'text-center': parent.props.showButtons && parent.props.buttonLayout == 'vertical' },

        // Spacing
        'p-3',
        'm-0',
        {
          'text-xs': parent.instance.$attrs['no-label'],
          'pt-6': parent.instance.$attrs['has-value'] && !parent.instance.$attrs['no-label'],
          'pt-3': !parent.instance.$attrs['has-value'],
        },

        // Shape
        'rounded h-12',
        { 'h-8': parent.instance.$attrs['boq-input'] },
        { 'rounded-r-none rounded-r-none': parent.props.showButtons },
        {
          'rounded-l-none rounded-l-none':
            parent.props.showButtons && parent.props.buttonLayout === 'horizontal',
        },
        { 'rounded-none': parent.props.showButtons && parent.props.buttonLayout === 'vertical' },

        {
          'rounded-none!':
            parent.instance.$parentInstance?.$name === 'InputGroup' && !parent.props.showButtons,
        },
        {
          'border-0':
            parent.instance.$parentInstance?.$name === 'InputGroup' && !parent.props.showButtons,
        },

        // Colors
        'text-txt-800',
        'placeholder:text-txt-600',
        'bg-transparent',
        'border-2',
        {
          'border-border-border-300':
            !parent.instance.$attrs['has-value'] &&
            !parent.instance.$attrs['claims-table'] &&
            !parent.instance.$attrs['boq-input'] &&
            (parent.instance.$attrs['no-label'] ||
              (!parent.instance.$attrs['no-label'] &&
                parent.instance.$attrs['universal-item-search'])) &&
            !parent.instance.$attrs['msisdn'] &&
            !context.disabled,
        },
        {
          'border-black':
            parent.instance.$attrs['has-value'] &&
            parent.instance.$attrs['claims-table'] &&
            parent.instance.$attrs['boq-input'] &&
            parent.instance.$attrs['no-label'] &&
            !parent.instance.$attrs['msisdn'] &&
            !context.disabled,
        },
        {
          'border-black':
            parent.instance.$attrs['universal-item-search'] &&
            !parent.instance.$attrs['no-label'] &&
            parent.instance.$attrs['has-value'] &&
            !parent.instance.$attrs['msisdn'] &&
            !context.disabled,
        },
        {
          'border-2 border-border-border-300':
            parent.instance.$attrs['boq-input'] &&
            (!parent.instance.$attrs['claims-table'] || !parent.instance.$attrs['has-value']) &&
            !parent.instance.$attrs['msisdn'] &&
            !context.disabled,
        },
        {
          'border-none': parent.instance.$attrs['msisdn'],
        },

        // States
        'focus:outline-none focus:outline-offset-0 focus:ring-0 focus:shadow-none',
        {
          'focus:border-blue-400': !context.disabled,
        },
        {
          'opacity-30 select-none cursor-not-allowed': context.disabled,
        },

        //Position
        {
          'order-2':
            parent.props.buttonLayout === 'horizontal' || parent.props.buttonLayout === 'vertical',
        },
      ],
    }),
  },
  buttongroup: () => ({
    class: [
      // Flex
      'flex',
      'flex-col',
    ],
  }),

  incrementbutton: {
    root: ({ parent }) => ({
      class: [
        // Display
        'flex flex-auto',

        // Alignment
        'items-center',
        'justify-center',
        'text-center align-bottom',

        //Position
        'relative',
        { 'order-3': parent.props.showButtons && parent.props.buttonLayout == 'horizontal' },
        { 'order-1': parent.props.showButtons && parent.props.buttonLayout == 'vertical' },

        //Color
        'text-black',
        'bg-transparent',
        'border border-text-dark-7-1 border-b-transparent border-l-transparent focus:border-accent-1-light-100',

        // Sizing
        'w-12',
        { 'px-4 py-3': parent.props.showButtons && parent.props.buttonLayout !== 'stacked' },
        { 'p-0': parent.props.showButtons && parent.props.buttonLayout == 'stacked' },
        { 'w-full': parent.props.showButtons && parent.props.buttonLayout == 'vertical' },

        // Shape
        'rounded-md',
        {
          'rounded-tl-none rounded-br-none rounded-bl-none':
            parent.props.showButtons && parent.props.buttonLayout == 'stacked',
        },
        {
          'rounded-bl-none rounded-tl-none':
            parent.props.showButtons && parent.props.buttonLayout == 'horizontal',
        },
        {
          'rounded-bl-none rounded-br-none':
            parent.props.showButtons && parent.props.buttonLayout == 'vertical',
        },

        //States
        'focus:outline-none focus:outline-offset-0 focus:ring',
        'hover:bg-primary-600 hover:border-primary-600',

        //Misc
        'cursor-pointer overflow-hidden select-none',
      ],
    }),
    label: {
      class: 'h-0 w-0',
    },
  },
  decrementbutton: {
    root: ({ parent }) => ({
      class: [
        // Display
        'flex flex-auto',

        // Alignment
        'items-center',
        'justify-center',
        'text-center align-bottom',

        //Position
        'relative',
        { 'order-1': parent.props.showButtons && parent.props.buttonLayout == 'horizontal' },
        { 'order-3': parent.props.showButtons && parent.props.buttonLayout == 'vertical' },

        //Color
        'text-black',
        'bg-transparent',
        'border border-text-dark-7-1 border-t-transparent border-l-transparent',

        // Sizing
        'w-12',
        { 'px-4 py-3': parent.props.showButtons && parent.props.buttonLayout !== 'stacked' },
        { 'p-0': parent.props.showButtons && parent.props.buttonLayout == 'stacked' },
        { 'w-full': parent.props.showButtons && parent.props.buttonLayout == 'vertical' },

        // Shape
        'rounded-md',
        {
          'rounded-tr-none rounded-tl-none rounded-bl-none':
            parent.props.showButtons && parent.props.buttonLayout == 'stacked',
        },
        {
          'rounded-tr-none rounded-br-none ':
            parent.props.showButtons && parent.props.buttonLayout == 'horizontal',
        },
        {
          'rounded-tr-none rounded-tl-none ':
            parent.props.showButtons && parent.props.buttonLayout == 'vertical',
        },

        //States
        'focus:outline-none focus:outline-offset-0 focus:ring',
        'hover:bg-primary-600 hover:border-primary-600',

        //Misc
        'cursor-pointer overflow-hidden select-none',
      ],
    }),
    label: {
      class: 'h-0 w-0',
    },
  },
};
